export default __webpack_public_path__ + "static/hall-16216a359a43d6e1132d343c24bb2d58.jpg";